import { AppContext } from "@/AppContext";
import Chip from "@/ui/Chip";
import { TopbarBreadcrumbItem } from "@/ui/Layout/Topbar/types";
import { Variants } from "@/ui/types";
import { X } from "@phosphor-icons/react";
import { useContext, useEffect, useState } from "react";

export const ContextChips = ({ onChange = (_newContext?: TopbarBreadcrumbItem[]) => {} }) => {
  const { currentlyViewing, setCurrentlyViewing } = useContext(AppContext);

  const [useForContext, setUseForContext] = useState<TopbarBreadcrumbItem[]>([]);

  useEffect(() => {
    setUseForContext(currentlyViewing as TopbarBreadcrumbItem[]);
  }, [currentlyViewing]);

  if (!useForContext.length) return null;
  if (useForContext.length === 1 && useForContext[0].label === "Launch Copilot") return null;

  return (
    <div className="flex flex-wrap gap-2">
      {useForContext.map((item, index) => {
        if (item.label === "") return null;
        return (
        <Chip
          key={index}
          variant={Variants.DISABLED}
          status={
            <div className="flex items-center gap-1">
              <span>{item.label}</span>
              <X
                onClick={() => {
                  const newContext = useForContext.filter(
                    (_, i) => i !== index
                  );
                  setCurrentlyViewing(newContext);
                  setUseForContext(newContext);
                  console.log("New context", newContext);
                  onChange(newContext);
                }}
                className="text-md cursor-pointer rounded hover:bg-black hover:text-white"
                style={{ padding: 1 }}
              />
            </div>
          }
        />
      )})}
    </div>
  );
};
